import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled, { useTheme } from 'styled-components';

import Grid from '@components/basics/grid';
import { getWidth } from '@components/styles';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import OnboardingArtist from '../../onboarding/onboarding-artist';

interface CreateArtistPageProps {
  className?: string;
}

export const CreateArtistPage: React.FC<CreateArtistPageProps> = (props) => {
  const theme = useTheme();

  return (
    <MotionOpacity>
      <OnboardingContainer className={props.className}>
        <Grid className="header" gap={10}>
          <Typography type="subheader" customFont="semi-bold">
            <Translate id="ARTIST.CREATE.TITLE" />
          </Typography>
          <Typography color={theme.colors.tertiary}>
            <Translate id="ARTIST.CREATE.TEXT" />
          </Typography>
        </Grid>

        <OnboardingArtist />
      </OnboardingContainer>
    </MotionOpacity>
  );
};

export default styled(CreateArtistPage)`
  margin: 0 auto;
  padding-top: 30px;
  min-height: calc(100vh - ${({ theme }) => theme.sizes.navbarMobile});

  @media ${({ theme }) => theme.device.tablet} {
    margin: 0 auto;
    padding-top: 60px;
    min-height: calc(100vh - ${({ theme }) => theme.sizes.navbar});
  }

  .header {
    margin-bottom: 20px;
  }
`;

const OnboardingContainer = styled.div`
  margin: auto;
  max-width: ${getWidth(6)};

  @media ${({ theme }) => theme.device.tablet} {
    max-width: ${getWidth(10)};
  }
`;
